var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 -1 12 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-sit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-sit",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999669,21.0000004 C7.55044985,21.0003279 7.12445291,20.7990107 6.83929571,20.4514753 C6.5541385,20.10394 6.43988803,19.6468307 6.528,19.206 L7.17,16 L4.49999669,16 C3.11928813,16 1.99999669,14.8807119 1.99999669,13.5 L1.99999669,7.5 C1.99885356,6.95309195 2.29545917,6.44890574 2.77405339,6.18422233 C3.25264761,5.91953892 3.83736739,5.93631386 4.3,6.228 L6.836,7.815 C7.5506674,8.2632912 8.37736859,8.50072948 9.221,8.5 L9.99999669,8.5 C10.8284271,8.5 11.4999967,9.17157288 11.4999967,10 C11.4999967,10.8284271 10.8284271,11.5 9.99999669,11.5 L9.221,11.5 C7.81535066,11.5000053 6.43799064,11.1049888 5.246,10.36 L4.99999669,10.206 L4.99999669,13 L7.78,13 C8.52905536,13.0000928 9.23860019,13.3360531 9.71337325,13.9154273 C10.1881463,14.4948016 10.3781145,15.2565333 10.231,15.991 L9.471,19.791 C9.33208642,20.4934457 8.71604953,20.9997602 7.99999669,21.0000004 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.5 L0,15 C0,15.5522847 0.44771525,16 1,16 L4.5,16",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 3,
    y2: 23,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 23,
    x2: 3,
    y2: 20.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 23,
    x2: 3,
    y2: 20.5,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSit);
export default __webpack_public_path__ + "static/media/icons-sit.5cfc751127a7e0aa1bec6164055608a8.svg";
export { ForwardRef as ReactComponent };